import * as utils from '@/utils'

export function formatDate (time, format, unit) {
  return utils.formatDate(time, format, unit)
}

export function showImage (imageId) {
  return imageId ? `${process.env.VUE_APP_IMG_SERVER}/${imageId}` : ''
}

export function showFirstImage (images) {
  const imageId = images.find(imageId => !!imageId)
  return showImage(imageId)
}

export function toRatio (current, total) {
  if (!total) return '0%'
  return `${((current / total) * 100).toFixed(2)}%`
}

export function fuzzyPhone (phone) {
  return phone.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2')
}
